import React, { forwardRef } from "react";
import { Icons } from "../../../utils/viewUtility";
import Utility from "../../../utils/utility";
import { LazyLoadImage } from "react-lazy-load-image-component";

const createIcon = forwardRef((props, ref) => {
  const { pwaIcon, dsaIcon, onMouseLeave, onMouseEnter } = props;
  let src = "";
  let imagePath = Utility.RES_PATH;

  if (pwaIcon) {
  } else if (dsaIcon) {
    imagePath = imagePath + "dsa/";
  } else {
    imagePath = imagePath + "portal/";
  }
  if (props.iconType) {
    src = imagePath + props.iconType + Icons.IMAGE_EXTENSTION;
  }
  return (
    <div ref={ref} style={{ display: "inline" }} onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
      <LazyLoadImage
        src={props.src || src}
        alt={props.iconType || "icon-image"}
        onClick={props.onClick ? props.onClick : () => {}}
        style={props.style ? props.style : {}}
        className={props.className ? props.className : ""}
        id={props.id}
        visibleByDefault={true}
      />
    </div>
  );
});
export default createIcon;
